<template>
  <div class="p-form-count">
    <ButtonCount
      type="button"
      kind="minus"
      :disabled="minusButtonDisabled"
      class="p-form-count__button"
      @click-button="changeCount(-1)"
    ></ButtonCount>
    <InputNumber
      v-model="count"
      :id="id"
      :name="name"
      class="p-form-count__input"
      :step="1"
      :min="min"
      :max="max"
      ref="input"
    ></InputNumber>
    <ButtonCount
      type="button"
      kind="plus"
      :disabled="plusButtonDisabled"
      class="p-form-count__button"
      @click-button="changeCount(1)"
    ></ButtonCount>
  </div>
</template>

<script lang="ts">
import ButtonCount from "@/common/components/atoms/ButtonCount.vue";
import InputNumber from "@/common/components/atoms/InputNumber.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    props: { type: String, required: false },
    name: { type: String, required: true },
    value: { type: Number, required: false, default: 0 },
    min: { type: Number, required: false, default: 0 },
    max: { type: Number, required: false, default: 9999 },
    stock: { type: Number, required: true, default: 0 },
    id: { type: [String, Number], required: true, default: 0 }
  },
  components: {
    ButtonCount,
    InputNumber
  }
})
export default class FormCount extends Vue {
  props!: string;
  name!: string;
  value!: number;
  min!: number;
  max!: number;
  stock!: any;
  id!: any;

  get minusButtonDisabled() {
    return this.count <= this.min;
  }
  get plusButtonDisabled() {
    return this.count >= this.max || this.stock == 0;
  }

  get count() {
    return this.value;
  }
  set count(value) {
    this.$emit("input", value);
  }

  changeCount(value: any) {
    let newCount = parseInt(this.count.toString(), 10);
    newCount += value;
    if (newCount < this.min) newCount = this.min;
    if (newCount > this.max) newCount = this.max;
    (this.$refs.input as any).changeCount(newCount);
  }
}
</script>

<style lang="scss" scoped>
.p-form-count {
  display: flex;
  align-items: center;

  &__input {
    width: rem(144);
    margin: 0 rem(8);

    @include sp {
      margin: 0 rem(12);
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
